export const eventTypesList = ['error', 'fatal', 'warning', 'success'];

export const eventTypes = {
    error: 'error',
    fatal: 'fatal',
    warning: 'warning',
    success: 'success',
};



// WEBPACK FOOTER //
// ./src/constants/events.js